// BlackMirror live beacon (assets/bm-live.js): where a visitor is now. Only with analytics consent, on the live
// theme, never in the editor or for bots. Changes nothing on the page, sets no cookie, sends no typed text.
// Contract: Live World plan, Section 4.
(function () {
  'use strict';
  var w = window;
  var d = w.document;
  var ENDPOINT = 'https://crm.futuremvmt.com/track/live';
  var STORES = {
    '8ae8d6.myshopify.com': 'eu',
    '0e45e8-18.myshopify.com': 'uk',
    'speediance.myshopify.com': 'au',
    'speediance-new-zealand.myshopify.com': 'nz',
  };
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var SECTION = '[id^="shopify-section-"]';
  var CLICKABLE = 'a[href],button,[role="button"],summary,input[type="submit"],input[type="button"],label';
  var MEDIA = 'img,picture,video';
  // Clicks in these carry only their kind word.
  var PRIVATE_UI = 'form,[role="dialog"],dialog,[data-bm-live="private"],predictive-search,[role="search"],' +
    '[role="listbox"],discount-form,.discount-form,.applied-discounts-container,.discounts,[data-myb-copy],[data-code],' +
    '[role="status"],[role="alert"]';
  var EXPRESS = '.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,' +
    '[data-shopify="payment-button"],.shopify-payment-button';
  var LOCALE = '^\\/(?:[a-z]{2}(?:-[a-z]{2})?\\/)?';
  var SEARCH_PATH = new RegExp(LOCALE + 'search(?:\\/|$)', 'i');
  var FILTER_PATH = new RegExp(LOCALE + 'collections\\/(?:vendors|types)\\/?$', 'i');
  var PRIVATE_PATH = new RegExp(LOCALE + '(?:(?:account|orders|checkouts?|gift_cards|challenge|tools|apps|a|discount|' +
    'cart\\/c|customer_authentication|customer_identity)(?:\\/|$)|cart\\/\\d+:)', 'i');
  // Sections named for these words are treated as data-bm-live="private".
  var PRIVATE_WORD = /^(?:contacts?|accounts?|orders?|lookup|login|logout|register|password|track|tracking)$/;
  var PRIVATE_JOIN = /orderlookup|ordertracking|trackorder|trackmyorder|contacthub|contactform/;
  var CHECKOUT = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/checkouts?(?:\/|$)/i;
  var SPACED = /(?:\+?\d[\s().\/-]?){8,}/;
  var PERSONAL = /@|\d{7}|[a-f0-9]{16}|(?:\+?\d[\s().\/-]?){8,}/i;
  var BOTS = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|prerender|preview/i;
  var CAPTURE = { capture: true, passive: true };
  var PASSIVE = { passive: true };
  var IDLE = 30 * 60 * 1000;
  var MAX_BODY = 4000;

  var store, lid, pl, visit, fresh, mode, page, title = '', heads = Object.create(null), mem = false, lastVis;
  var seq = 0, first = true, running = false, dead = false, polls = 0, hiddenAt = 0, lastBeatAt = 0;
  var depth = 0, current = -1, clicks = [], lastEl = null, lastAt = 0, live = {}, sentAt = [];
  var els = [], ids = [], keys = [], labels = [], index = Object.create(null);
  var timers = {}, undo = [], io = null, po = null;

  function now() { return Date.now(); }
  function noop() {}
  function safe(fn) {
    return function () {
      try { return fn.apply(this, arguments); } catch (e) { /* never break the storefront */ }
    };
  }
  function cut(text, max) {
    return String(text == null ? '' : text).slice(0, 400).replace(/\s+/g, ' ').trim().slice(0, max);
  }
  function round2(n) { return Math.round(Math.min(1, Math.max(0, n)) * 100) / 100; }
  // An email, 5 digits in a row or a spaced number gives the fallback.
  function clean(text, fallback, max) {
    var s = cut(text, Math.max(max, 100));
    return !s || s.indexOf('@') !== -1 || /\d{5}/.test(s) || SPACED.test(s) ? fallback : s.slice(0, max).trim();
  }

  function clear(name) {
    if (timers[name] != null) { w.clearTimeout(timers[name]); timers[name] = null; }
  }
  function after(name, ms, fn) {
    clear(name);
    timers[name] = w.setTimeout(safe(function () { timers[name] = null; fn(); }), ms);
  }
  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    undo.push(function () { target.removeEventListener(type, fn, opts); });
  }
  function shown() { return d.visibilityState === 'visible'; }

  function getItem(key) { try { return w.localStorage.getItem(key); } catch (e) { return null; } }
  function setItem(key, value) {
    try { w.localStorage.setItem(key, value); return true; } catch (e) { return false; }
  }
  function dropItem(key) { try { w.localStorage.removeItem(key); } catch (e) { /* storage blocked */ } }
  function uuid() {
    var c = w.crypto, b, h = '', i;
    if (c && typeof c.randomUUID === 'function') return c.randomUUID();
    if (!c || typeof c.getRandomValues !== 'function') return null;
    b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    for (i = 0; i < 16; i++) h += (b[i] + 256).toString(16).slice(1);
    return [h.slice(0, 8), h.slice(8, 12), h.slice(12, 16), h.slice(16, 20), h.slice(20)].join('-');
  }

  // The id is read from storage at every run and beat; it stays in memory only if storage fails (mem).
  function storedId() {
    try { return w.localStorage.getItem('bm_live_id'); } catch (e) { return undefined; }
  }
  // An id this browser stored that another tab deleted (consent withdrawn) is not replaced until consent is given
  // here or the page comes back from the cache (again): null, nothing runs.
  function browserId(again) {
    var id = storedId();
    if (UUID.test(id || '')) { lid = id; mem = false; return false; }
    if (lid && (mem || id === undefined)) return false;
    if (lid && id === null && !again) return null;
    lid = uuid();
    mem = id === undefined || (!!lid && !setItem('bm_live_id', lid));
    return true;
  }

  // The visit is shared by all tabs and ends 30 minutes after the last visible beat.
  function readVisit() {
    try { return JSON.parse(getItem('bm_live_visit')); } catch (e) { return null; }
  }
  function alive(v, t) { return !!v && UUID.test(String(v.id)) && t - v.lastAt <= IDLE; }
  function loadVisit(renewed) {
    var t = now(), old = (!renewed && readVisit()) || {}, ok = alive(old, t);
    var n = Math.max(0, Math.min(old.number | 0, 99));
    fresh = !ok;
    return {
      id: ok ? old.id : uuid(),
      startedAt: ok ? old.startedAt : t,
      lastAt: ok && !shown() ? old.lastAt : t,
      number: ok ? Math.max(n, 1) : Math.min(n + 1, 99),
      pages: ok ? old.pages | 0 : 0,
      cartAdds: ok ? old.cartAdds | 0 : 0,
      checkout: ok && old.checkout === true,
    };
  }
  // A newer live visit of another tab is joined, never written over, so racing tabs settle on one.
  function newer(v) {
    return v.startedAt > visit.startedAt || (v.startedAt === visit.startedAt && String(v.id) > visit.id);
  }
  function save() {
    var cur;
    if (!mem && storedId() !== lid) return; // another tab deleted or replaced this browser's id
    cur = readVisit();
    if (cur && cur.id !== visit.id && alive(cur, now()) && newer(cur)) {
      visit = { id: cur.id, startedAt: cur.startedAt, lastAt: Number(cur.lastAt) || 0,
        number: Math.max(1, Math.min(cur.number | 0, 99)), pages: 0, cartAdds: 0, checkout: visit.checkout };
    }
    if (cur && cur.id === visit.id) {
      visit.pages = Math.max(visit.pages, cur.pages | 0);
      visit.cartAdds = Math.max(visit.cartAdds, cur.cartAdds | 0);
      visit.checkout = visit.checkout || cur.checkout === true;
      visit.lastAt = Math.max(visit.lastAt, Number(cur.lastAt) || 0);
    }
    if (shown()) visit.lastAt = now();
    setItem('bm_live_visit', JSON.stringify(visit));
  }
  function forget() {
    lid = null;
    mem = false;
    dropItem('bm_live_id');
    dropItem('bm_live_visit');
  }

  // Personal looking and account, order, checkout or app paths go as /other. Search pages read no page text.
  function pageOf(raw, query) {
    var p = String(raw || '/'), dec = p, i;
    try {
      for (i = 0; i < 3 && dec.indexOf('%') !== -1; i++) dec = decodeURIComponent(dec);
    } catch (e) { return { path: '/other', kind: 'other' }; }
    if (PERSONAL.test(dec) || PRIVATE_PATH.test(dec)) return { path: '/other', kind: 'other' };
    if (SEARCH_PATH.test(dec) || (FILTER_PATH.test(dec) && new w.URLSearchParams(query).has('q'))) {
      return { path: p.slice(0, 200), kind: 'search' };
    }
    return { path: p.slice(0, 200), kind: 'page' };
  }

  function sectionKey(id) {
    var s = String(id).replace('shopify-section-', ''), i = s.lastIndexOf('__');
    if (i !== -1) s = s.slice(i + 2);
    return s.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 60);
  }
  function privateKey(id) { // a whole word of the key, or a joined name
    var s = String(id).replace('shopify-section-', ''), i = s.lastIndexOf('__');
    s = s.slice(i < 0 ? 0 : i + 2).replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    return s.split(/[^a-z]+/).some(function (t) { return PRIVATE_WORD.test(t); }) ||
      PRIVATE_JOIN.test(s.replace(/[^a-z0-9]/g, ''));
  }
  function humanise(key) {
    var name = key.replace(/[_-]+/g, ' ').trim() || 'section';
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  // Headings are read once at load: a section may later write the shopper's name into one.
  function readHeadings() { // the first heading outside PRIVATE_UI
    var list = d.querySelectorAll(SECTION), i, j, el, hs, h;
    for (i = 0; i < list.length; i++) {
      el = list[i];
      if (String(el.id).indexOf('sections--') !== -1 || el.closest('[data-bm-live="private"]') ||
        privateKey(el.id)) continue;
      hs = el.querySelectorAll('h1,h2,h3');
      for (h = null, j = 0; j < hs.length && !h; j++) if (!hs[j].closest(PRIVATE_UI)) h = hs[j];
      heads[el.id] = clean(h && h.textContent, '', 60);
    }
  }
  function collect() {
    var list = d.querySelectorAll(SECTION), seen = Object.create(null), i, el, k, base, n;
    els = []; ids = []; keys = []; labels = []; index = Object.create(null);
    for (i = 0; i < list.length && els.length < 40; i++) {
      el = list[i];
      if (String(el.id).indexOf('sections--') !== -1) continue;
      k = base = sectionKey(el.id) || 's' + els.length;
      n = 1;
      while (seen[k]) k = base.slice(0, 56) + '-' + (++n);
      seen[k] = true;
      if (index[el.id] == null) index[el.id] = els.length;
      els.push(el); ids.push(el.id); keys.push(k);
      labels.push((page.kind === 'page' && heads[el.id]) || humanise(k));
    }
  }
  function find(el) {
    var id = el && el.id;
    return id && index[id] != null ? index[id] : -1;
  }
  function refresh() {
    var i, el;
    for (i = 0; i < els.length; i++) {
      if (els[i].isConnected !== false || !(el = d.getElementById(ids[i]))) continue;
      if (io) { io.unobserve(els[i]); io.observe(el); }
      els[i] = el;
    }
  }

  function pick() {
    var mid = w.innerHeight / 2, i, r;
    for (i = 0; i < els.length; i++) {
      r = els[i].getBoundingClientRect();
      if (r.top <= mid && r.bottom >= mid) return i;
    }
    return -1;
  }
  function setCurrent(i) {
    if (i < 0 || i === current) return;
    current = i;
    after('section', 1500, send);
  }
  function onSeen(entries) {
    var i, next = -1;
    refresh();
    entries.forEach(function (en) {
      var at = find(en.target);
      if (at < 0 || els[at] !== en.target) return; // the old element of a swapped section
      if (en.isIntersecting) live[at] = true; else delete live[at];
    });
    for (i = 0; i < els.length; i++) { if (live[i]) { next = i; break; } }
    setCurrent(next);
  }
  function measure() {
    var h = d.documentElement.scrollHeight, p;
    if (!(h > 0)) return;
    p = Math.round(100 * ((w.pageYOffset || 0) + w.innerHeight) / h);
    depth = Math.max(depth, Math.min(p, 100));
  }
  function onScroll() {
    if (timers.scroll != null) return;
    after('scroll', 250, function () { refresh(); measure(); if (!io) setCurrent(pick()); });
  }

  function soon() { if (timers.click == null) after('click', 1000, send); }

  function privateLink(href) {
    var u;
    try { u = new w.URL(href, w.location.href); } catch (e) { return true; }
    if (u.origin !== w.location.origin) { // Shopify's own account pages
      return /\/account(\/|$)/.test(u.pathname) || u.hostname.indexOf('account.') === 0;
    }
    return PRIVATE_PATH.test(u.pathname);
  }
  // Same site: the path (checkout as /checkout). Other sites: the hostname. mailto: and tel: nothing.
  function targetOf(href) {
    var u;
    try {
      u = new w.URL(href, w.location.href);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      if (u.origin !== w.location.origin) return u.hostname;
      if (CHECKOUT.test(u.pathname)) return '/checkout';
      return pageOf(u.pathname, u.search).path; // decoded: private and personal paths are /other
    } catch (e) { return null; }
  }
  function altOf(el, tag) {
    var img = tag === 'img' ? el : el.querySelector('img[alt]');
    return img ? img.getAttribute('alt') : '';
  }
  // No element text off plain pages, in PRIVATE_UI, private sections or on account links; over 50 descendants:
  // aria-label only.
  function labelOf(el, hit, tag, kind) {
    var sec = el.closest(SECTION);
    if (page.kind !== 'page' || el.closest(PRIVATE_UI) || (sec && privateKey(sec.id)) ||
      (tag === 'a' && privateLink(hit.getAttribute('href')))) {
      return kind;
    }
    if (hit.getElementsByTagName('*').length > 50) return clean(hit.getAttribute('aria-label'), kind, 48);
    return clean(hit.getAttribute('aria-label') || hit.innerText || (tag === 'input' ? hit.value : '') ||
      altOf(hit, tag), kind, 48);
  }
  function onClick(e) {
    var el = e.target, hit, tag, kind = 'button', target = null, sec, i, r, x = null, y = null, t, express;
    if (e.isTrusted === false || !el || typeof el.closest !== 'function') return;
    express = el.closest(EXPRESS);
    hit = express || el.closest(CLICKABLE) || el.closest(MEDIA);
    if (!hit) return;
    tag = String(hit.tagName).toLowerCase();
    if (express) target = '/checkout';
    else if (hit !== el.closest(CLICKABLE)) kind = 'media';
    else if (tag === 'a') kind = 'link';
    else if (tag === 'summary' || tag === 'label' || hit.getAttribute('aria-expanded') !== null) kind = 'toggle';
    t = now();
    if (hit === lastEl && t - lastAt < 50) return; // a label forwards its click to its input
    lastEl = hit; lastAt = t;
    if (tag === 'a' && !express) target = targetOf(hit.getAttribute('href'));
    if (target === '/checkout' || hit.getAttribute('name') === 'checkout') visit.checkout = true;
    sec = el.closest(SECTION);
    i = sec ? find(sec) : -1;
    if (e.clientX || e.clientY) {
      x = round2(e.clientX / w.innerWidth);
      if (i >= 0) {
        r = sec.getBoundingClientRect();
        if (r.height > 0) y = round2((e.clientY - r.top) / r.height);
      }
    }
    clicks.push({ k: kind, l: express ? 'Express checkout' : labelOf(el, hit, tag, kind), t: target,
      s: i >= 0 ? keys[i] : null, x: x, y: y });
    if (clicks.length > 10) clicks.shift();
    soon();
  }
  function onBlur() {
    var f = d.activeElement;
    if (!consent()) return;
    if (visit.checkout || !f || String(f.tagName).toUpperCase() !== 'IFRAME' || !f.closest(EXPRESS)) return;
    visit.checkout = true;
    save();
    soon();
  }
  // A same-site /cart/add with a 2xx status, or with none (Safari reports none). Status 0 never counts.
  function onResources(list) {
    var added = 0;
    if (!consent()) return;
    list.getEntries().forEach(function (en) {
      var u, s = en.responseStatus;
      try { u = new w.URL(en.name, w.location.href); } catch (e) { return; }
      if (u.origin !== w.location.origin) return;
      if (u.pathname.indexOf('/cart/add') !== -1 && (s === undefined || (s >= 200 && s < 300))) added += 1;
    });
    if (!added) return;
    save();
    visit.cartAdds += added;
    save();
    soon();
  }

  // Once per visit. None when the referrer is this store and there are no tags: the source is unknown.
  function landing() {
    var out = {}, q = new w.URLSearchParams(w.location.search), host = '';
    ['utm_source', 'utm_medium', 'tmsrc'].forEach(function (k) {
      var v = clean(q.get(k), '', 60);
      if (v) out[k] = v;
    });
    ['gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) { if (q.has(k)) out[k] = true; });
    try { host = new w.URL(d.referrer).hostname; } catch (e) { /* no referrer */ }
    if (host && host === w.location.hostname && Object.keys(out).length === 0) return null;
    if (host) out.referrer = host;
    return out;
  }
  function build(leave) {
    var b, i, l;
    measure();
    b = { v: 1, store: store, lid: lid, vid: visit.id, pl: pl, seq: ++seq, path: page.path };
    if (first) {
      if (title) b.title = title;
      if (page.kind !== 'other' && els.length) {
        b.sections = [];
        for (i = 0; i < els.length; i++) b.sections.push({ k: keys[i], l: labels[i] });
      }
    }
    if (current >= 0) b.sec = { k: keys[current], l: labels[current] };
    b.depth = depth;
    b.vis = lastVis = shown();
    if (w.navigator && w.navigator.maxTouchPoints > 1) b.tp = 1; // an iPad reports a Mac user agent
    b.vw = Math.round(w.innerWidth) || 0;
    b.vn = visit.number;
    b.pages = visit.pages;
    b.cartAdds = visit.cartAdds;
    b.checkout = visit.checkout;
    if (first && fresh && !mode && (l = landing())) b.landing = l;
    if (clicks.length) b.clicks = clicks.splice(0);
    if (leave) b.leave = true;
    return b;
  }
  function bytes(s) { return new w.Blob([s]).size; }
  // fetch first: unlike sendBeacon it can omit cookies. sendBeacon only if fetch is missing or throws; a fetch
  // that fails later may have arrived and is not resent. text/plain avoids a CORS preflight.
  function transmit(json) {
    var nav = w.navigator, p;
    lastBeatAt = now();
    if (typeof w.fetch === 'function') {
      try {
        p = w.fetch(ENDPOINT, { method: 'POST', body: json, keepalive: true, mode: 'cors', credentials: 'omit',
          headers: { 'Content-Type': 'text/plain' } });
        if (p && typeof p.catch === 'function') p.catch(noop);
        return;
      } catch (e) { /* fall back to sendBeacon */ }
    }
    try {
      if (nav && typeof nav.sendBeacon === 'function') nav.sendBeacon(ENDPOINT, new w.Blob([json], { type: 'text/plain' }));
    } catch (e) { /* a lost beat is fine */ }
  }
  // At least 2 seconds apart and at most 20 a minute; an early beat folds into the next allowed one.
  function wait() {
    var t = now();
    while (sentAt.length && t - sentAt[0] >= 60000) sentAt.shift();
    if (!sentAt.length) return 0;
    return Math.max(0, sentAt[sentAt.length - 1] + 2000 - t, sentAt.length >= 20 ? sentAt[0] + 60000 - t : 0);
  }
  function send(leave) {
    var b, json, id, ms, t = now();
    if (!running) return;
    if (!consent()) { halt(); forget(); return; }
    // Frozen or asleep past the visit's end: shown, a new run; hidden, asleep.
    if ((lastBeatAt && t - lastBeatAt > IDLE) || (hiddenAt && t - hiddenAt >= IDLE)) {
      halt();
      if (!leave) { if (shown()) begin('wake'); else sleep(); }
      return;
    }
    id = mem ? lid : storedId();
    if (id !== undefined && id !== lid) { // deleted: wait; replaced: a new run with it
      halt();
      if (!leave && id !== null) { lid = null; begin(); }
      return;
    }
    if (shown()) hiddenAt = 0; else if (!hiddenAt) hiddenAt = t;
    ms = leave ? 0 : wait();
    if (shown() !== lastVis && sentAt.length < 20) ms = 0; // a hide may be the last chance to send
    clear('click'); clear('section');
    if (ms > 0) { after('beat', ms, send); return; }
    save();
    b = build(leave);
    json = JSON.stringify(b);
    while (bytes(json) > MAX_BODY && (b.clicks || b.sections)) {
      if (b.clicks) { b.clicks.shift(); if (!b.clicks.length) delete b.clicks; } else {
        b.sections.pop();
        if (!b.sections.length) delete b.sections;
      }
      json = JSON.stringify(b);
    }
    first = false;
    sentAt.push(t);
    transmit(json);
    if (leave) return;
    if (shown()) after('beat', 15000, send);
    else if (now() - hiddenAt < IDLE) after('beat', 60000, send);
    else sleep();
  }
  // Hidden 30 minutes: everything stops until the page is shown again.
  function sleep() {
    halt();
    on(d, 'visibilitychange', safe(function () {
      if (!shown()) return;
      halt();
      if (consent()) begin('wake'); else if (!pending()) forget();
    }), PASSIVE);
  }

  function api() {
    var p = w.Shopify && w.Shopify.customerPrivacy;
    return p && typeof p.analyticsProcessingAllowed === 'function' ? p : null;
  }
  function consent() {
    var p;
    try {
      p = api();
      return !!p && p.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  // currentVisitorConsent().analytics: 'yes', 'no' or ''. '' with shouldShowBanner() true is still pending.
  function asked() {
    var p = api(), c;
    try {
      if (!p || typeof p.currentVisitorConsent !== 'function' || typeof p.shouldShowBanner !== 'function') return '';
      c = p.currentVisitorConsent() || {};
      if (c.analytics === '' && p.shouldShowBanner() === true) return 'pending';
      return c.analytics === 'no' ? 'no' : '';
    } catch (e) { return ''; }
  }
  function pending() { return asked() === 'pending'; }

  function begin(how, again) {
    var renewed;
    if (running || dead || d.prerendering) return;
    renewed = browserId(again);
    if (!lid || renewed === null) return;
    visit = loadVisit(renewed);
    if (how !== 'wake' || fresh) visit.pages += 1;
    mode = how;
    pl = uuid();
    running = true; first = true; seq = 0; hiddenAt = 0; lastBeatAt = 0; depth = 0; clicks = []; live = {};
    try {
      collect();
      current = pick();
    } catch (e) { els = []; ids = []; keys = []; labels = []; index = Object.create(null); current = -1; }
    on(d, 'click', safe(onClick), CAPTURE);
    on(d, 'visibilitychange', safe(function () { send(); }), PASSIVE);
    on(d, 'resume', safe(function () { send(); }), PASSIVE);
    on(w, 'blur', safe(onBlur), PASSIVE);
    on(w, 'scroll', safe(onScroll), PASSIVE);
    try {
      if (els.length && typeof w.IntersectionObserver === 'function') {
        io = new w.IntersectionObserver(safe(onSeen), { rootMargin: '-50% 0px -50% 0px' });
        els.forEach(function (el) { io.observe(el); });
      }
    } catch (e) { io = null; }
    try {
      if (typeof w.PerformanceObserver === 'function') {
        po = new w.PerformanceObserver(safe(onResources));
        po.observe({ type: 'resource' });
      }
    } catch (e) { po = null; }
    send();
  }
  function halt() {
    running = false;
    Object.keys(timers).forEach(clear);
    undo.splice(0).forEach(function (off) { off(); });
    if (io) io.disconnect();
    if (po) po.disconnect();
    io = po = null;
  }
  // The privacy API may answer late: ask for 10 seconds. A final no forgets.
  function look() {
    if (dead || running) return;
    if (consent()) { begin(); return; }
    if (api() && (asked() === 'no' || (polls >= 20 && !pending()))) forget();
    if (polls++ < 20) after('consent', 500, look);
  }
  function onConsent() {
    if (dead) return;
    if (consent()) begin('', true); else { halt(); forget(); }
  }
  function onHide() {
    try { if (running) send(true); } finally { halt(); dead = true; }
  }
  function onShow(e) {
    if (!e.persisted) return;
    dead = false;
    if (consent()) begin('restore', true); else if (!pending()) forget();
  }

  function boot() {
    var shopify = w.Shopify, script = d.currentScript || d.querySelector('script[data-store][src*="bm-live"]');
    var domain = script ? script.getAttribute('data-store') : null, nav = w.navigator;
    if (!Object.prototype.hasOwnProperty.call(STORES, domain)) return;
    store = STORES[domain];
    if (!shopify || !shopify.theme || shopify.theme.role !== 'main' || shopify.designMode) return;
    if (nav && (nav.webdriver || BOTS.test(String(nav.userAgent || '').replace(/cubot/gi, '')))) return;
    page = pageOf(w.location.pathname, w.location.search);
    title = page.kind === 'search' ? 'Search' : page.kind === 'page' ? clean(d.title, '', 120) : '';
    try { if (page.kind === 'page') readHeadings(); } catch (e) { /* section names */ }
    w.addEventListener('pagehide', safe(onHide));
    w.addEventListener('pageshow', safe(onShow));
    d.addEventListener('visitorConsentCollected', safe(onConsent));
    if (d.prerendering) d.addEventListener('prerenderingchange', safe(look), { once: true });
    else look();
  }

  try {
    if (w.__bmLive) return;
    w.__bmLive = true;
    boot();
  } catch (e) { /* never break the storefront */ }
})();
